<template>
  <div class="block">
    <div class="block-header block-header-default d-flex">
      <h3 class="block-title">Venues To Call</h3>
      <div>
        Last Updated {{ lastUpdatedString }}
        <button
          v-if="shouldUpdate"
          class="btn btn-info btn-sm ml-3"
          @click="getVenues()"
        >
          <i class="si si-refresh"></i>
        </button>
      </div>
    </div>
    <div class="block-content">
      <div class="row">
        <div
          v-if="data['partners'] && data['partners'].length"
          class="col col-sm-10 col-md-4 col-lg-3"
        >
          <select
            id="partnerId"
            v-model="filters.partner_id"
            class="form-control"
            @change="getVenues()"
          >
            <option :value="null">- All Partners -</option>
            <option v-for="partner in data['partners']" :value="partner.id">
              {{ partner.name }}
            </option>
          </select>
        </div>
        <div
          v-if="data['campaigns'] && data['campaigns'].length"
          class="col col-sm-10 col-md-4 col-lg-2"
        >
          <select
            id="campaignId"
            v-model="filters.invitedToCampaignId"
            class="form-control"
            :disabled="
              data['partners'] && data['partners'].length && !filters.partner_id
            "
            @change="getVenues()"
          >
            <option :value="null">- All Campaigns -</option>
            <option
              v-for="campaign in data['campaigns']"
              v-if="
                (data['partners'] &&
                  data['partners'].length &&
                  filters.partner_id &&
                  campaign.partner_id == filters.partner_id) ||
                  !data['partners'] ||
                  !data['partners'].length
              "
              :value="campaign.id"
            >
              {{ campaign.name }}
            </option>
          </select>
        </div>
        <div
          v-if="data['campaigns'] && data['campaigns'].length"
          class="col col-sm-10 col-md-4 col-lg-2"
        >
          <multiselect
            id="campaignStatuses"
            v-model="selected_statuses"
            :close-on-select="false"
            :hide-selected="true"
            label="name"
            :multiple="true"
            :options="data['campaignStatuses']"
            placeholder="Campaign Status(es)"
            track-by="id"
            @input="getVenues(true)"
          ></multiselect>
        </div>
        <div class="col col-sm-10 col-md-4 col-lg-2">
          <multiselect
            id="statuses"
            v-model="selected_venue_statuses"
            :close-on-select="false"
            :hide-selected="true"
            label="name"
            :multiple="true"
            :options="data['statuses']"
            placeholder="Venue Status(es)"
            track-by="id"
            @input="getVenues(true)"
          ></multiselect>
        </div>
        <div class="col col-sm-10 col-md-4 col-lg-2">
          <multiselect
            id="productStatuses"
            v-model="selected_product_statuses"
            :close-on-select="false"
            :hide-selected="true"
            label="name"
            :multiple="true"
            :options="data['productStatuses']"
            placeholder="Product Status(es)"
            track-by="id"
            @input="getVenues(true)"
          ></multiselect>
        </div>
		  <div
			   
			  class="col col-sm-10 col-md-4 col-lg-2"
		  >
			  <select
				  id="prefContactMethod"
				  v-model="filters.prefContactMethod"
				  class="form-control"
				  @change="getVenues()"
			  >
				  <option :value="null">- All Preferences -</option>
				  <option v-for="method in data['prefContactMethod']" :value="method.id">
					  {{ method.name }}
				  </option>
			  </select>
		  </div>
        <div class="col col-sm-2 col-md-1">
          <button
            class="btn btn-light btn-sm text-muted nav-main-link"
            v-on:click="resetData"
          >
            <i class="si si-reload fa-1x mr-1"></i>
            <span>Reset</span>
          </button>
        </div>
      </div>
      <table
        v-if="venues && venues.length"
        class="table table-borderless table-striped table-vcenter font-size-sm mt-2"
      >
        <thead>
          <th>Venue</th>
          <th>Campaign Status</th>
          <th>Venue Status</th>
		  <th>Last Call</th>
          <th>Last Emailed</th>
          <th>Created</th>
          <th>Pref. Contact Method</th>
          <th></th>
          <th></th>
        </thead>
        <tbody>
          <tr v-for="(venue, index) in venues">
            <td class="font-w600 text-left">
              {{ venue.name }}
            </td>
            <td class="d-none d-sm-table-cell">{{ venue.campaignStatus }}</td>
            <td class="d-none d-sm-table-cell">{{ venue.statusName }}</td>
            <td class="d-none d-sm-table-cell">
              {{
                venue.last_called && venue.last_called !== '0000-00-00 00:00:00'
                  ? Bandwango.dateToLocal(venue.last_called)
                  : ''
              }}
            </td>
            <td class="d-none d-sm-table-cell">
              {{
                venue.last_emailed &&
                venue.last_emailed !== '0000-00-00 00:00:00'
                  ? Bandwango.dateToLocal(venue.last_emailed)
                  : ''
              }}
            </td>
            <td class="d-none d-sm-table-cell">
              {{ Bandwango.dateToLocal(venue.created_at) }}
            </td>
			  <td class="d-none d-sm-table-cell">
				  {{ prefContactMethod(venue) }}
			  </td>
            <td class="d-none d-sm-table-cell">
              <span v-if="venue.canCall && !shouldUpdate">
                <button
                  class="btn btn-primary btn-sm"
                  @click.prevent="goToVenue(venue)"
                >
                  <i class="fa fa-phone-alt"></i>
                </button>
              </span>
              <span v-else-if="venue.lockedByName">
				  <i class="fa fa-lock" :id="'locked-'+venue.id"></i>
				  <b-tooltip triggers="hover" :target="'locked-'+venue.id" placement="top">
					  Locked by {{ venue.lockedByName }}
				  </b-tooltip>
              </span>
            </td>
            <td class="d-none d-sm-table-cell">
              <v-btn
                  color="light-blue lighten-1 white--text"
                  depressed
                  fab
                  :href="getMpLink(venue)"
                  x-small
                  target="_blank"
              >
                MP
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <h4 class="mb-2 mt-2">No Venues</h4>
        <p>Please make sure a campaign is selected.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: {}
    }
  },
  components: {},
  methods: {

	  getContactMethods() {
		  return [
			  { id: 'email', name: 'Email' },
			  { id: 'phone', name: 'Phone' },
			  ];
	  },
    getMpLink({ id: venueId }) {
      return `/merchant-portal/${venueId}/dashboard/main/view-dashboard`;
    },
	  prefContactMethod(venue) {
		  if(venue.settings && venue.settings.prefContactMethod) {
			  const method = this.getContactMethods().find(m => m.id === venue.settings.prefContactMethod);
			  if(method) return method.name;
		  }
		  return 'Not Selected';
	  },
    getVenues() {
      const self = this;

      if (this.data.partner && this.data.partner.id)
        this.filters.partner_id = this.data.partner.id;

      if (!this.filters.invitedToCampaignId) return;

      const campaign = this.data.campaigns.find(
        x => x.id === this.filters.invitedToCampaignId
      );
      if (campaign) {
        let now = moment();
        if (this.data.partner && this.data.partner.timezone)
          now = moment().tz(this.data.partner.timezone);

		if( this.filters.lastCalled ) delete this.filters.lastCalled;
		
		this.filters.nextCall = Bandwango.dateToUtc( now);
									
        this.filters.sortBy = 'next_call';
        this.filters.sortDesc = false;
      }

      this.cookieFilters();
      const url = `${
        this.data.superAdmin ? '/superAdmin' : ''
      }/venues?display=20&latestCampaign=true&lock=callCenter`;

      // // TODO:: clean this up!
      // url += '&'+Object.keys(this.filters).map(function(key) {
      // 	if( self.filters[key] ) { // don't pass nulls
      // 		if( Array.isArray(self.filters[key]) ) {
      // 			self.filters[key].forEach((v) => {
      // 				return encodeURIComponent(key) + '[]=' + encodeURIComponent(v);
      // 			});
      // 		} else {
      // 			return encodeURIComponent(key) + '=' + encodeURIComponent(self.filters[key]);
      // 		}
      // 	}
      // }).join('&');
      $.ajax({
        url,
        type: 'GET',
        data: this.filters,
        success(resp) {
          self.venues = resp.data;
          if (self.venues && self.venues.length) {
			  //set venues.canCall to true for every venue in list
			  self.venues.forEach(v => {
				  v.canCall = !v.lockedByName;
			  });
			  
		  }

          self.lastUpdated = new Date();
          self.updateDate();
        }
      });
    },
	  setCookieVenueFilters: function(venueId) {
		  this.filters.lastVenueId = venueId;
		  const date = new Date();
		  date.setHours(23,59,59,999);
		  const expires = "expires=" + date.toGMTString();
		  document.cookie = "callcenter-venue-filters="+JSON.stringify(this.filters)+"; "+expires+";path=/";
	  },
    updateDate() {
      if (this.dateTimeout) clearTimeout(this.dateTimeout);

      this.lastUpdatedString = moment(this.lastUpdated).fromNow();
      this.shouldUpdate = moment(this.lastUpdated)
        .add(5, 'minute')
        .isBefore(moment());
      this.dateTimeout = setTimeout(this.updateDate, 10000);
    },

    resetData() {
      Object.keys(this.filters).forEach(key => {
        if (key === 'statuses') this.filters[key] = [];
        else this.filters[key] = null;
      });
      this.venues = [];
      // this.getVenues();
      this.cookieFilters();
    },

    updateCallable() {
      // flag the next venue in line as callable
      this.venues.forEach(v => {
        if (   !v.canCall && !v.lockedBy) {
          
          v.canCall = true;
        } else v.canCall = false;
      });
    },

    goToVenue(venue) {
      // let url = '/superAdmin/callCenters/'+venue.id;
      let url = `/admin/${this.data.partner?.id || venue.partner_id}/callCenters/${venue.id}`;

      if (venue.campaignId) url += `/${venue.campaignId}`;

      if (this.data.superAdmin) url += '?cameFrom=superAdmin';
      this.setCookieVenueFilters(venue.id);
      window.location = url;
    },

    cookieFilters() {
      // Need cookie for filters. Name should be TYPE-filters.
      const date = new Date();
      date.setHours(23, 59, 59, 999);
      const expires = `expires=${date.toGMTString()}`;
      document.cookie = `callcenter-venue-filters=${JSON.stringify(
        this.filters
      )}; ${expires};path=/`;
    },
    getCookie(name) {
		let cookieArr = document.cookie.split("; ");
		for(let i = 0; i < cookieArr.length; i++) {
			let cookiePair = cookieArr[i].split("=");
			if(name == cookiePair[0]) {
				return decodeURIComponent(cookiePair[1]);
			}
		}
		return null;
	}
  },
  data() {
    return {
      venues: [],
      lastUpdated: new Date(),
      lastUpdatedString: '',
      shouldUpdate: false,
      filters: {
        partner_id: null,
        invitedToCampaignId: null,
        statuses: [],
        campaignStatuses: [],
        productStatuses: [],
		prefContactMethod: null,
		  
      },
      dateTimeout: null
    };
  },
  beforeMount() {},
  mounted() {
	  let filterCookie = this.getCookie('callcenter-venue-filters');
	  if(filterCookie) {
		  this.filters = JSON.parse(filterCookie);
		  this.data.filters = JSON.parse(filterCookie);
	  }
    if (this.data.filters) this.filters = this.data.filters;
    if (!this.filters.statuses) this.filters.statuses = [];
    if (!this.filters.campaignStatuses) this.filters.campaignStatuses = [];
    if (!this.filters.statusStatuses) this.filters.statusStatuses = [];

    // reset page back to 1; Other components are changing callcenter-venue-filters
    this.filters.page = 1;

    this.getVenues();
    this.updateDate();

    Echo.channel('edit-event')
      .listen('ClosedItem', ev => {
        if (ev.assignment === 'venue') {
          const f = this.venues.find(x => x.id === ev.assignmentId);
          if (f) {
            f.lockedBy = '';
            this.updateCallable();
          }
          this.$forceUpdate();
        }
      })
      .listen('OpenedItem', ev => {
        if (ev.assignment === 'venue') {
          const f = this.venues.find(x => x.id === ev.assignmentId);
          if (f) {
            //f.canCall = false;
            f.lockedBy = (ev.user && ev.user.name) || '';
            this.updateCallable();
          }
          this.$forceUpdate();
        }
      });
  },
  computed: {
    selected_statuses: {
      get() {
        if (this.filters.campaignStatuses) {
          return this.data.campaignStatuses.filter(
            status =>
              this.filters.campaignStatuses.map(Number).indexOf(status.id) > -1
          );
        }

        return [];
      },
      set(newVal) {
        this.filters.campaignStatuses = newVal.map(v => v.id);
      }
    },
    selected_venue_statuses: {
      get() {
        if (this.filters.statuses) {
          return this.data.statuses.filter(
            status => this.filters.statuses.map(Number).indexOf(status.id) > -1
          );
        }

        return [];
      },
      set(newVal) {
        this.filters.statuses = newVal.map(v => v.id);
      }
    },
    selected_product_statuses: {
      get() {
        if (this.filters.productStatuses) {
          return this.data.productStatuses.filter(
            status =>
              this.filters.productStatuses.map(Number).indexOf(status.id) > -1
          );
        }

        return [];
      },
      set(newVal) {
        this.filters.productStatuses = newVal.map(v => v.id);
      }
    },
  },
};
</script>
